import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { TNextButtonHook } from '~/src/features/full-buy/containers/GoToNextStepButton/types';
import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import getSubscriptionsWithConditions from '~/src/features/full-buy/store/selectors/getSubscriptionsWithConditions';

const subscriptionPlural = getPluralize(['подписку', 'подписки', 'подписок']);

const useSubscriptionsNextButton = (): TNextButtonHook => {
    const analytics = useAnalytics();
    const dispatch = useDispatch();

    const { leftToSelect, tariffName } = useSelector(getSubscriptionsWithConditions);

    return {
        disabled: Boolean(leftToSelect),
        onClick: (e: SyntheticEvent) => {
            e.stopPropagation();
            analytics.tariff.choose(tariffName);

            dispatch(goToNextStep());
        },
        children: leftToSelect ? `Выберите ${leftToSelect} ${subscriptionPlural(leftToSelect)}` : 'Продолжить',
    };
};

export default useSubscriptionsNextButton;
